module.exports = __webpack_public_path__ + "img/bank_04.b77d685f.png";